/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:42:41
 * @LastEditTime: 2021-06-25 09:56:04
 * @Description: axios配置
 */
import axios from 'axios'
import router from '../router/index'

const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV)

export let baseURL = "";
if (process.env.NODE_ENV === "production" && process.env.type === "analyz") {
    // baseURL = "";
} else if (IS_PROD) {
    baseURL = "//zidaiot.com/api";
    // baseURL = "//192.168.4.56:9000/api";
} else {
    baseURL = "//127.0.0.1:9000/api";
}

let instance = axios.create({
    baseURL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    let token = localStorage.getItem("token");
    config.headers["token"] = token;
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error.response.data);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Do something with response data
    return response.data;
}, function (error) {
    // Do something with response error
    if (error.response.status === 401) {
        localStorage.removeItem("token");
        router.push("/login");
    }
    if (error.response.status === 403) {
        return '您没有这个权限'
    }
    return Promise.reject(error.response.data);
});

export default instance;